import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

type DateRangePreset =
  | "today"
  | "yesterday"
  | "last_7_days"
  | "last_30_days"
  | "this_year"
  | "custom"

const DATE_RANGE_PRESETS: DateRangePreset[] = [
  "today",
  "yesterday",
  "last_7_days",
  "last_30_days",
  "this_year",
  "custom"
]

// Keys a JSON locale file can hold — `files.filters.dateRangePresets.<key>`.
const DATE_RANGE_LABEL_KEYS: Record<DateRangePreset, string> = {
  today: "today",
  yesterday: "yesterday",
  last_7_days: "last7Days",
  last_30_days: "last30Days",
  this_year: "thisYear",
  custom: "custom"
}

interface DateRangeFilterState {
  date_range: DateRangePreset | null
  date_after: string | null
  date_before: string | null
}

// Day boundaries are cut in UTC, matching the server's clock.
const matchesDateRange = (
  createdISO: string,
  filters: DateRangeFilterState,
  now: dayjs.Dayjs = dayjs.utc()
): boolean => {
  if (!filters.date_range) return true
  const created = dayjs.utc(createdISO)

  if (filters.date_range === "custom") {
    if (filters.date_after && created.isBefore(dayjs.utc(filters.date_after).startOf("day"))) {
      return false
    }
    if (filters.date_before && created.isAfter(dayjs.utc(filters.date_before).endOf("day"))) {
      return false
    }
    return true
  }

  if (filters.date_range === "today") {
    return !created.isBefore(now.startOf("day"))
  }
  if (filters.date_range === "yesterday") {
    const start = now.subtract(1, "day").startOf("day")
    return !created.isBefore(start) && created.isBefore(now.startOf("day"))
  }
  if (filters.date_range === "last_7_days") {
    return !created.isBefore(now.subtract(7, "day").startOf("day"))
  }
  if (filters.date_range === "last_30_days") {
    return !created.isBefore(now.subtract(30, "day").startOf("day"))
  }
  if (filters.date_range === "this_year") {
    return !created.isBefore(now.startOf("year"))
  }
  return true
}

export { DATE_RANGE_LABEL_KEYS, DATE_RANGE_PRESETS, matchesDateRange }
export type { DateRangeFilterState, DateRangePreset }
